import { Icon } from '@zapier/zinnia-icons';
import { Icon as LegacyIcon } from '../components/display/Icon';
import { ReactElement, ReactNode, isValidElement } from 'react';

const typeSet = new Set<string | Function>([
  'img',
  'svg',
  'picture',
  Icon,
  LegacyIcon,
]);

export function isIconElement(element: ReactNode): element is ReactElement {
  return isValidElement(element) && typeSet.has(element.type);
}
